import { ComponentType } from "react";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { toSerializableKeyEvent } from "@multiweb/reactUtils";
import { AllowedMenuItemCodes } from "@multiweb/types/contracts";
import { IAppState } from "@multiweb/types/react";
import { createSetAllowedMenuItemCodesAction, createSetMenuPanelCaptionsVisibilityAction, createSetMenuVisibilityAction } from "../../actions";
import { createFocusDefaultItemAction, createKeyPressedAction, createMenuFocusLostAction } from "../../navigation";
import { isMenuFloated, isMenuFloatTransitionActive, isMenuVisible, isSubmenuListExpanded } from "../../selectors";
import { MenuVisibility } from "../../types";
import { MainMenuComponent, MainMenuComponentProps } from "../MainMenuComponent";

export type MainMenuProps = {
    /** Aliasy povolených kořenových formulářových uzlů hlavního navigačního menu. */
    allowedMenuItemCodes: AllowedMenuItemCodes;
    /** Příznak, zda je menu v počátečním stavu viditelné a nepřekrývající. */
    showMenuExpanded: boolean;
    /** Pokud je true, u položek menu panelu se zobrazí popisek. Pokud je false, popisky se nezobrazí. */
    showMenuPanelCaptions: boolean;
};

type StateProps = Pick<MainMenuComponentProps, "isMenuVisible" | "isSubmenuListExpanded" | "isMenuFloated" | "menuFloatTransitionActive">;

const mapStateToProps: MapStateToProps<StateProps, MainMenuProps, IAppState> = (state) => ({
    isMenuVisible: isMenuVisible(state),
    isMenuFloated: isMenuFloated(state),
    isSubmenuListExpanded: isSubmenuListExpanded(state),
    menuFloatTransitionActive: isMenuFloatTransitionActive(state),
});

type DispatchProps = Pick<MainMenuComponentProps, "loadAllowedMenuItemCodes" | "setInitialExpandedState" | "setInitialMenuPanelCaptionsVisibility" | "onKeyPressed" | "onFocusHandler" | "onBlurHandler">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, MainMenuProps> = (dispatch, { allowedMenuItemCodes, showMenuExpanded, showMenuPanelCaptions }) => ({
    loadAllowedMenuItemCodes: () => dispatch(createSetAllowedMenuItemCodesAction(allowedMenuItemCodes)),
    setInitialExpandedState: () => dispatch(createSetMenuVisibilityAction(showMenuExpanded ? MenuVisibility.expanded : MenuVisibility.hidden)),
    setInitialMenuPanelCaptionsVisibility: () => dispatch(createSetMenuPanelCaptionsVisibilityAction(showMenuPanelCaptions)),
    onKeyPressed: (event) => dispatch(createKeyPressedAction(toSerializableKeyEvent(event))),
    onFocusHandler: () => dispatch(createFocusDefaultItemAction()),
    onBlurHandler: (documentHidden: boolean) => dispatch(createMenuFocusLostAction(documentHidden)),
});

export const MainMenu: ComponentType<MainMenuProps> = connect(mapStateToProps, mapDispatchToProps)(MainMenuComponent);
